import React from 'react'
import { Lottie } from '@crello/react-lottie'

import '../App.scss'

import Layout from '../components/Layout'
import Text from '../components/Text'

import countdown from '../static/tik.json'
import recording from '../static/listening.json'
import photo from '../static/photo.jpg'

export default ({ step, isReady, isRecording }) => {
  return (
    <>
      <Layout>
        {
          [
            <Layout fade key={1}>
              <Text large center>
                Cough 3 times
              </Text>

              <Layout>
                <Text center>Make sure you are sitting upright.</Text>
              </Layout>
            </Layout>,
            <Layout fade key={2}>
              <Text large center>
                Breathe deeply 3 times
              </Text>

              <Layout>
                <Text center>
                  Inhale and then exhale heavily <strong>through the mouth</strong>.
                </Text>

                <Text center>
                  Your lungs should be almost completely filled with air on each inhalation, then
                  emptied with each exhalation.
                </Text>
              </Layout>
            </Layout>,
            <Layout fade key={3}>
              <Text large center>
                Describe the photo with a sentence or a two
              </Text>

              <Layout>
                <Text center>Try to speak for 15 – 20 seconds.</Text>
              </Layout>

              <Layout style={{ position: 'relative' }} highlight>
                <img src={photo} style={{ width: '100%', margin: '0 auto', position: 'absolute', top: 0, left: 0 }} alt="" />
              </Layout>
            </Layout>
          ][step - 1]
        }
      </Layout>

      <Layout fade key={0} style={{ display: 'block', flex: 'none', height: 150, opacity: 0.8 }}>
        {isReady && (
          <Lottie
            key={isRecording}
            height={150}
            config={{
              animationData: isRecording ? recording : countdown,
              autoplay: true,
              loop: isRecording
            }}
          />
        )}
      </Layout>
    </>
  )
}
